import { getValueBetweenMinMax } from './getValueBetweenMinMax';
import { DEFAULT_VALUE } from '../constants/guests';

export function getSafeGuestsCount(value: number | null | undefined, minValue: number, maxValue: number): number {
  return getValueBetweenMinMax(value, minValue, maxValue) || DEFAULT_VALUE;
}
